module.exports = __webpack_public_path__ + "img/Garden & Outdoor.5c65fb86.png";